/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".document-introduction[_ngcontent-%COMP%]{margin-top:32px}.document-introduction[_ngcontent-%COMP%]   .image[_ngcontent-%COMP%]{text-align:center}.document-introduction[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#231d19;font-size:32px;font-weight:900;line-height:32px;text-align:left;margin-top:40.73px;margin-bottom:24px}"];
export { styles as styles };
